export const SALES_MULTIPLIER = 0.1;
